export class PlusShopEditorText {
  texts = {
    submit_form_title: ET('mps2::landing::plus::submit_form_title'),
    submit_form_description: ET('mps2::landing::plus::submit_form_description'),
    submit_form_company: ET('mps2::landing::plus::submit_form_company'),
    submit_form_company_category: ET('mps2::landing::plus::submit_form_company_category'),
    submit_form_manager: ET('mps2::landing::plus::submit_form_manager'),
    submit_form_manager_email: ET('mps2::landing::plus::submit_form_manager_email'),
    submit_form_manager_phone: ET('mps2::landing::plus::submit_form_manager_phone'),
    submit_form_file: ET('mps2::landing::plus::submit_form_file'),
    submit_form_other: ET('mps2::landing::plus::submit_form_other'),
    submit_form_agree: ET('mps2::landing::plus::submit_form_agree'),
    submit_form_agree_content: ET('mps2::landing::plus::submit_form_agree_content'),
    submit_form_marketing: ET('mps2::landing::plus::submit_form_marketing'),
    submit_form_marketing_content: ET('mps2::landing::plus::submit_form_marketing_content'),
    submit_form_button: ET('mps2::landing::plus::submit_form_button'),
    submit_form_email_error: ET('mps2::landing::plus::submit_form_email_error'),
    submit_form_phone_error: ET('mps2::landing::plus::submit_form_phone_error'),
    submit_form_guide: ET('mps2::landing::plus::submit_form_guide'),
    enterprise_category: ET('mps2::landing::plus::enterprise_category'),
    private_enterprise: ET('mps2::landing::plus::private_enterprise'),
    corporate_enterprise: ET('mps2::landing::plus::corporate_enterprise'),
    public_enterprise: ET('mps2::landing::plus::public_enterprise'),
    social_enterprise: ET('mps2::landing::plus::social_enterprise'),
    etc_enterprise: ET('mps2::landing::plus::etc_enterprise'),
  } as const;

  mo_texts = {
    submit_form_title: ET('mps2::landing::plus::submit_form_title'),
    submit_form_description: ET('mps2::landing::plus::submit_form_description'),
    submit_form_company: ET('mps2::landing::plus::mo_submit_form_company'),
    submit_form_company_category: ET('mps2::landing::plus::submit_form_company_category'),
    submit_form_manager: ET('mps2::landing::plus::mo_submit_form_manager'),
    submit_form_manager_email: ET('mps2::landing::plus::mo_submit_form_manager_email'),
    submit_form_manager_phone: ET('mps2::landing::plus::mo_submit_form_manager_phone'),
    submit_form_file: ET('mps2::landing::plus::mo_submit_form_file'),
    submit_form_other: ET('mps2::landing::plus::mo_submit_form_other'),
    submit_form_agree: ET('mps2::landing::plus::submit_form_agree'),
    submit_form_agree_content: ET('mps2::landing::plus::submit_form_agree_content'),
    submit_form_marketing: ET('mps2::landing::plus::submit_form_marketing'),
    submit_form_marketing_content: ET('mps2::landing::plus::submit_form_marketing_content'),
    submit_form_button: ET('mps2::landing::plus::mo_submit_form_button'),
    submit_form_email_error: ET('mps2::landing::plus::submit_form_email_error'),
    submit_form_phone_error: ET('mps2::landing::plus::submit_form_phone_error'),
    submit_form_guide: ET('mps2::landing::plus::submit_form_guide'),
    enterprise_category: ET('mps2::landing::plus::enterprise_category'),
    private_enterprise: ET('mps2::landing::plus::private_enterprise'),
    corporate_enterprise: ET('mps2::landing::plus::corporate_enterprise'),
    public_enterprise: ET('mps2::landing::plus::public_enterprise'),
    social_enterprise: ET('mps2::landing::plus::social_enterprise'),
    etc_enterprise: ET('mps2::landing::plus::etc_enterprise'),
  } as const;

  getTexts = (is_mobile: boolean) => {
    return is_mobile ? this.mo_texts : this.texts;
  };
}
